export const menuConstants = {
  BLANK_LINK: "#!",
};